import { h } from "snabbdom";
import type { VNode } from "snabbdom";
import type { Msg, RegistryConflict } from "../types";

// Shown when an attempted registry save was rejected: the listed pages still
// use a tag/value the change would strand. No override — the user must fix each
// page, then save again. Clicking a page opens it.
export function viewRegistryConflicts(
  conflicts: RegistryConflict[],
  dispatch: (msg: Msg) => void
): VNode {
  const byTag = new Map<string, RegistryConflict[]>();
  for (const c of conflicts) {
    const list = byTag.get(c.tagName) ?? [];
    list.push(c);
    byTag.set(c.tagName, list);
  }

  return h(
    "div.vb-overlay",
    { on: { click: () => dispatch({ type: "DismissRegistryConflicts" }) } },
    [
      h("div.vb-dialog.conflicts", { on: { click: (e: Event) => e.stopPropagation() } }, [
        h("h2.conflicts__title", "Can't save these tag changes"),
        h(
          "p.conflicts__hint",
          "Some pages still use a tag or value you changed. Fix them first, then save again."
        ),
        ...[...byTag.entries()].map(([tag, list]) =>
          h("div.conflicts__group", [
            h("div.conflicts__tag", [
              h("strong", tag),
              ` — ${list.length} page${list.length === 1 ? "" : "s"}: ${list[0]!.reason}`,
            ]),
            h(
              "ul.conflicts__pages",
              list.slice(0, 5).map((c) =>
                h(
                  "li.conflicts__page",
                  {
                    on: {
                      click: () => {
                        dispatch({ type: "DismissRegistryConflicts" });
                        dispatch({ type: "NavigateTo", id: c.cardId });
                      },
                    },
                  },
                  c.preview.trim() || "(untitled page)"
                )
              )
            ),
            ...(list.length > 5 ? [h("p.conflicts__more", `…and ${list.length - 5} more`)] : []),
          ])
        ),
        h("div.conflicts__actions", [
          h(
            "button.vb-btn",
            { on: { click: () => dispatch({ type: "DismissRegistryConflicts" }) } },
            "OK"
          ),
        ]),
      ]),
    ]
  );
}
